module.exports = __webpack_public_path__ + "static/media/CompletedStepperIcon.fc5eaa6b.svg";